
export default function HowItWorksSection() {
  const steps = [
    {
      number: '1',
      icon: 'ri-download-line',
      title: 'Download Vollet',
      description: 'Get the app from Google Play or App Store. It\'s free to download and use.',
    },
    {
      number: '2',
      icon: 'ri-wallet-3-line',
      title: 'Create or import wallet',
      description: 'Set up a new wallet in seconds, or import an existing one with your recovery phrase.',
    },
    {
      number: '3',
      icon: 'ri-rocket-line',
      title: 'Start sending & receiving',
      description: 'You\'re ready! Send, receive, and manage your crypto with ease.',
    },
  ];

  return (
    <section id="how-it-works" className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Get started in 3 simple steps
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From download to your first transaction in minutes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-1/2 w-full h-0.5 bg-gray-200">
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 bg-gray-200 rotate-45"></div>
                </div>
              )}
              
              <div className="text-center relative z-10">
                <div className="w-24 h-24 bg-[#4C6FFF] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-[#4C6FFF]/30">
                  <i className={`${step.icon} text-3xl text-white`}></i>
                </div>
                <div className="inline-flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full text-sm font-bold text-gray-600 mb-4">
                  {step.number}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed max-w-xs mx-auto">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
